<template>
  <div>
    <h3>Reimpressões {{ $gui.ticketOfLC }} {{ number }}</h3>

    <p v-if="reprints.length === 0" class="text-muted">
      Nenhuma reimpressão registrada.
    </p>

    <b-list-group v-else>
      <b-list-group-item v-for="entry in reprints" :key="entry.position">
        {{ entry.position }}ª — {{ entry.dealer }} — {{ entry.created_at | date }}
      </b-list-group-item>
    </b-list-group>
  </div>
</template>

<script>
export default {
  name: 'OrganizerTicketReprints',
  data () {
    return {
      organizer: this.$route.params.organizer,
      number: this.$route.params.number,
      reprints: []
    }
  },
  mounted () {
    this.getReprints()
  },
  methods: {
    async getReprints () {
      let url = process.env.VUE_APP_URL_APP + '/b/organizers/' + this.organizer + '/tickets/' + this.number + '/reprints'

      try {
        let res = await this.$http.get(url)
        this.reprints = res.body.reprints
      } catch (e) {
        console.error(e)
      }
    }
  }
}
</script>
